import { IPlacementMarginDetailsResponse } from '../add-edit-placement-scenario.model';

export const initialPlacementMarginDetailResponseState: IPlacementMarginDetailsResponse[] = [
  {
    placementId: 0,
    placementStartDate: undefined,
    placementEndDate: undefined,
    placementDuration: 0,
    facility: {
      facilityId: null,
      facilityName: '',
      facilityAddress1: '',
      facilityAddress2: '',
      facilityState: '',
      facilityCity: '',
      facilityZip: null,
      facilityLongitude: null,
      facilityLatitude: null,
      facilityCountry: '',
      facilityRegionId: null,
    },
    travelerId: null,
    candidateNameFirst: '',
    candidateNameMiddle: '',
    candidateNameLast: '',
    candidateNameGoesBy: '',
    brandId: null,
    brand: '',
    orderId: null,
    disciplineId: null,
    specialtyId: null,
    subspecialtyId: null,
    shiftId: null,
    shift: '',
    isScenarioExtention: null,
    extensionNumber: null,
    isExtensionOfPriorPlacement: null,
    extensionOfPriorPlacementId: null,
    bookingPeriodId: null,
    bookingPeriodStartDate: undefined,
    bookingPeriodEndDate: undefined,
    bookingPeriodDuration: null,
    isMostRecentBookingPeriod: false,
    packageName: '',
    recruiter: {
      employeeId: null,
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
    },
    accountManager: {
      employeeId: null,
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
    },
    scenarios: [
      {
        placementId: 0,
        bookingPeriodId: null,
        scenarioId: null,
        scenarioName: '',
        scenarioStatusId: null,
        scenarioStatus: '',
        tla: null,
        createdUserId: null,
        createdUserFirst: '',
        createdUserLast: '',
        createdDateAt: undefined,
        updatedUserId: null,
        updatedUserFirst: '',
        updatedUserLast: '',
        updatedDateAt: undefined,
        grossMargin: null,
        grossProfit: null,
        revenue: null,
        negotiatedContributionMargin: '',
        approvedUserId: null,
        approvedUserFirst: '',
        approvedUserLast: '',
        approvedDateAt: undefined,
        approvedReasonId: '',
        verifiedUserId: null,
        verifiedUserFirst: '',
        verifiedUserLast: '',
        verifiedDateAt: undefined,
        verifiedReasonId: null,
        notes: '',
        interimPayPackageTimeOffId: null,
        isDefaultScenario: false,
        isMostRecentBookingPeriod: false,
        splits: [
          {
            placementId: 0,
            bookingPeriodId: null,
            scenarioId: null,
            splitId: null,
            effectiveStartDate: undefined,
            effectiveEndDate: undefined,
            billRate: null,
            overtime: null,
            holiday: null,
            callback: null,
            billGuaranteedHours: null,
            billAmountPerMile: null,
            payAmountPerMile: null,
            splitPlacementId: null,
            housingCoPay: null,
            lodgingPerDiem: null,
            standardFurniture: null,
            housingTypeId: null,
            housingType: '',
            earlyMoveInDays: null,
            earlyMoveInDaysWaived: null,
            earlyMoveInCostPerDay: null,
            lateMoveOutDays: null,
            lateMoveOutDaysWaived: null,
            lateMoveOutCostPerDay: null,
            mealPerDiem: null,
            cellPhoneStipend: null,
            tlaMealAllowance: null,
            tlaCarAllowance: null,
            tlaShiftCompletionBonus: null,
            additionalPremiumPay: null,
            shiftId: null,
            shift: '',
            hoursPerWeek: null,
            hoursPerShift: null,
            healthInsuranceTypeId: null,
            healthInsuranceType: '',
            isWaitingPeriodBenefit: null,
            tlaCellPhoneStipend: null,
            vms: null,
            other: null,
            billDoubletimeRate: null,
            billOvertimeFactor: null,
            billCallBackFactor: null,
            billDoubletimeFactor: null,
            billHolidayFactor: null,
            billOnCallRate: null,
            billCharge: null,
            billPreceptor: null,
            orientationHours: null,
            isVoidOrientationHours: null,
            payRate: null,
            payOvertimeFactor: null,
            payCallBackFactor: null,
            payDoubletimeFactor: null,
            payHolidayFactor: null,
            payOnCallRate: null,
            payGuaranteedHours: null,
            payCharge: null,
            payPreceptor: null,
            csfSupervisorCosts: null,
            additionalCostMiscellaneousAmount: null,
            additionalCostMiscellaneousDescription: '',
            furnitureCoPay: null,
            isEarlyMoveIn: false,
            isLateMoveOut: false,
            earlyMoveInDate: undefined,
            lateMoveOutDate: undefined,
            rentCost: null,
            utilities: null,
            rentOverrideNot: '',
            miscellaneousFurnitureDescription: '',
            orientationFactor: null,
            orientationRate: null,
            furnitureCosts: [],
            moveInDate: undefined,
            moveOutDate: undefined,
            timeOffs: [],
            payPackageDetailsValues: [],
            isAssignmentSplit: false,
          },
        ],
      },
    ],
  },
];
